import { hexToRgbA } from "../../../helpers/Util";
import { SET_ENV_VARIABLES, GET_ENV_VARIABLES, CLEAR_ENV_VARIABLES } from "./actionTypes";

const initialState = {
    env: {
        "API_ENV": process.env.REACT_APP_API_ENV,
        "API_HOST": process.env.REACT_APP_API_HOST,
        "AVATAR": process.env.REACT_APP_AVATAR,
        "BANNER": process.env.REACT_APP_BANNER,
        "DESCRIPTION": process.env.REACT_APP_DESCRIPTION,
        "ENABLE_TRADING_FEE": process.env.REACT_APP_ENABLE_TRADING_FEE,
        "FAVICON": process.env.REACT_APP_FAVICON,
        "NAME": process.env.REACT_APP_NAME,
        "PRIMARY_COLOR": process.env.REACT_APP_PRIMARY_COLOR,
        "ROOT_HOST": process.env.REACT_APP_ROOT_HOST,
        "STAKING_TOKENS": process.env.REACT_APP_STAKING_TOKENS,
        "SUPPORTED_CUSTODIANS": process.env.REACT_APP_SUPPORTED_CUSTODIANS,
        "SUPPORTED_TOKENS": process.env.REACT_APP_SUPPORTED_TOKENS,
        "TOKEN_MANAGEMENT_NAME": process.env.REACT_APP_TOKEN_MANAGEMENT_NAME,
        "TOKEN_MANAGEMENT_TOKENS": process.env.REACT_APP_TOKEN_MANAGEMENT_TOKENS,
        "TRADABLE_TOKENS": process.env.REACT_APP_TRADABLE_TOKENS,
        "VARIANT": process.env.REACT_APP_VARIANT
      },
    org: "",
    loading: false,
    error: null
};

const variables = (state = initialState, action) => {
    switch (action.type) {
        case GET_ENV_VARIABLES:
            return {
                ...state,
                env: {},
                org: action.payload.org,
                loading: true,
                error: null,  // Reset error on new request
            };

        case SET_ENV_VARIABLES:
            const env = action.payload?.vars?.reduce((acc, v) => {
                acc[v.key] = v.value;
                return acc;
            }, {});
            if (Object.keys(env).length) {
                localStorage.setItem("env", JSON.stringify(env));
                document.getElementById("favicon").href = `/${env.FAVICON}`;
                document.getElementById("description").href = env.DESCRIPTION;
                document.getElementById("title").innerHTML = env.NAME;
                document.documentElement.style.setProperty("--primary", env.PRIMARY_COLOR);
                document.documentElement.style.setProperty("--primary-light", hexToRgbA(env.PRIMARY_COLOR, 0.25));
            }
            return {
                ...state,
                env: { ...state.env, ...env }, // Ensure no break if `vars` is missing
                error: action.payload?.error || null,
                loading: false
            };

        case CLEAR_ENV_VARIABLES:
            localStorage.removeItem("env");
            return {
                ...initialState  // Reset state to initial values
            };

        default:
            return state; // No mutation, just return the original state
    }
};

export default variables;
